function isTableRowLine(line: string): boolean {
  const trimmed = line.trim();
  return trimmed.startsWith('|') && trimmed.endsWith('|') && trimmed.length >= 3;
}

function isTableSeparatorLine(line: string): boolean {
  const trimmed = line.trim();
  if (!trimmed.startsWith('|') || !trimmed.endsWith('|')) return false;
  const inner = trimmed.slice(1, -1);
  const chars = inner.split('');
  return chars.every(c => c === '-' || c === ':' || c === ' ' || c === '\t' || c === '|');
}

export function detectMarkdownTable(
  lines: string[],
  startIndex: number,
): { endIndex: number; tableText: string } | null {
  if (startIndex >= lines.length) return null;

  const firstLine = lines[startIndex].trim();
  if (!isTableRowLine(firstLine)) return null;

  if (startIndex + 1 >= lines.length) return null;
  const secondLine = lines[startIndex + 1].trim();
  if (!isTableSeparatorLine(secondLine)) return null;

  let endIndex = startIndex + 2;
  while (endIndex < lines.length && isTableRowLine(lines[endIndex].trim())) {
    endIndex++;
  }

  const tableLines = lines.slice(startIndex, endIndex);
  return {
    endIndex: endIndex - 1,
    tableText: tableLines.join('\n'),
  };
}
